import DotsLoading from 'components/loadings/dotsLoading'
import React from 'react'
interface IWalletBalanceProps {
    wallet_balance: number | undefined
    isLoading: boolean
}
export default function WalletBalance({
    wallet_balance,
    isLoading,
}: IWalletBalanceProps) {
    return (
        <div className=" grow items-center w-full flex justify-center -mt-20">
            {isLoading ? (
                <DotsLoading />
            ) : (
                <div className="w-full mx-6">
                    <div className=" bg-[#A1E5001F] shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px] rounded-lg py-8 px-8 text-center">
                        <p className=" text-xl">موجودی کیف پول:</p>
                        <p className=" text-green-1 text-xl mt-3">
                            {Number(wallet_balance).toLocaleString()}{' '}
                            <span className=" text-black">تومان</span>
                        </p>
                    </div>
                    <p className=" mt-4 text-center">
                        حداقل مبلغ شارژ کیف پول، به دلیل محدودیت پرداخت از درگاه
                        ۵,۰۰۰ تومان است.
                    </p>
                </div>
            )}
        </div>
    )
}
